import { homedir } from "node:os";
import { join } from "node:path";

/** tktuner data directory: $XDG_DATA_HOME/tktuner or ~/.local/share/tktuner. */
export function dataDir(): string {
  const xdg = process.env.XDG_DATA_HOME;
  const base = xdg && xdg.trim() !== "" ? xdg : join(homedir(), ".local", "share");
  return join(base, "tktuner");
}
